<div mat-dialog-content fxLayout="column" fxLayoutAlign="start">
    <div class="posting-container">
        <mat-icon class="close-dialog" (click)="dialogRef.close(false)">close</mat-icon>
        <div class="layer"></div>
        <div class="posting-image" *ngIf="featuredWidget[index].image" [style.background-image]="'url(' + featuredWidget[index].image.url + ')'"></div>
        <div class="posting-title" fxLayout="column" fxLayoutAlign="center center">
            <mat-chip-set class="mb-4" tabIndex="-1" *ngIf="featuredWidget[index].postingType.displayNameKeySingular">
                <mat-chip class="accent-500" [disableRipple]="true">{{ featuredWidget[index].postingType.displayNameKeySingular | translate }}</mat-chip>
            </mat-chip-set>
            <h2 tabIndex="0" class="text-center">{{ featuredWidget[index].translation.title }}</h2>
        </div>
        <div class="swiper-button-prev-container" *ngIf="!isFirst" (click)="prevPost()">
            <div class="swiper-button-prev"></div>
        </div>
        <div class="swiper-button-next-container" *ngIf="!isLast" (click)="nextPost()">
            <div class="swiper-button-next"></div>
        </div>
    </div>
    <div class="posting-content p-16 p-sm-40">
        <p [innerHTML]="featuredWidget[index].translation.description | safeHtml"></p>
    </div>
</div>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center" class="pt-24 mb-0 action-buttons" *ngIf="featuredWidget[index].url">
    <app-flat-button [label]="featuredWidget[index].postingType.actionButtonTextKey" (onClick)="openPostingUrl()"></app-flat-button>
</div>
